import {css} from 'lit';
export const styles = css`:host {
  --app-primary-color: #01965f;
  --app-primary-color-400: #017243;

  --app-secondary-color: black;

  --accent-color: var(--google-red-500);
  --accent-color-400: var(--google-red-300);

  --accent-home: var(--google-red-500);
  --accent-home-400: var(--google-red-300);
  --accent-away: var(--google-green-500);
  --accent-away-400: var(--google-green-300);
}

:host {
    display: flex;
    padding: 8px;
    cursor: pointer;
}

.team {
    padding: 3px 0;

    flex-grow: 1; /* grow to remaining space*/
    flex-basis: 0; /* equal size */
}

.home {

}

.away {
    text-align: right
}

.twoLines {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.score {
    padding: 3px 0px;
    font-weight: bolder;
    background: #ddd;
    width: 55px;
    text-align: center;
}

.icon {
    width: 32px;
    height: 32px;
    margin: 0px 6px;
}

.ONGOING {
    color: var(--google-red-500);
}

.SCHEDULED {
    font-weight: lighter !important;
}

.NOT_RELEVANT {
    font-weight: lighter !important;
    font-style: italic;
}

`;
export default styles;
